import React, { ReactElement } from "react";
import { FormattedMessage } from "react-intl";

import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import IconSelector from "components/shared/images/IconSelector";

import { IFirewallRuleData } from "types/api/baremetalApiInterface";

const RuleToEdit = ({
 rule,
 disabledEdit,
 editSelectedRule
}: {
 rule: IFirewallRuleData;
 disabledEdit: boolean;
 editSelectedRule: () => void;
}): ReactElement => {
 return (
  <Paper sx={{ p: 2, minWidth: 950 }}>
   <Stack direction="row" spacing={2} textAlign="left" justifyContent="space-between">
    <Stack sx={{ overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
     <Typography fontWeight="bold" variant="caption">
      <FormattedMessage id="baremetal.firewall.name" />
     </Typography>
     <Typography variant="caption" width={150}>
      {rule.name || "Not available"}
     </Typography>
    </Stack>
    <Stack>
     <Typography fontWeight="bold" variant="caption">
      <FormattedMessage id="baremetal.firewall.protocol" />
     </Typography>
     <Typography variant="caption" minWidth={100}>
      {rule.protocol || "Not available"}
     </Typography>
    </Stack>
    <Stack>
     <Typography fontWeight="bold" variant="caption">
      <FormattedMessage id="baremetal.firewall.sourceIp" />
     </Typography>
     <Typography variant="caption" minWidth={100}>
      {rule.src_ip || "Not available"}
     </Typography>
    </Stack>
    <Stack>
     <Typography fontWeight="bold" variant="caption">
      <FormattedMessage id="baremetal.firewall.destinationIp" />
     </Typography>
     <Typography variant="caption" minWidth={100}>
      {rule.dst_ip || "Not available"}
     </Typography>
    </Stack>
    <Stack>
     <Typography fontWeight="bold" variant="caption">
      <FormattedMessage id="baremetal.firewall.sourcePort" />
     </Typography>
     <Typography variant="caption" minWidth={100}>
      {rule.src_port || "Not available"}
     </Typography>
    </Stack>
    <Stack>
     <Typography fontWeight="bold" variant="caption">
      <FormattedMessage id="baremetal.firewall.destinationPort" />
     </Typography>
     <Typography variant="caption" minWidth={100}>
      {rule.dst_port || "Not available"}
     </Typography>
    </Stack>
    <Stack>
     <Typography fontWeight="bold" variant="caption">
      <FormattedMessage id="baremetal.firewall.action" />
     </Typography>
     <Typography variant="caption" minWidth={100}>
      {rule.action || "Not available"}
     </Typography>
    </Stack>
    <Stack alignItems="center" justifyContent="center">
     <IconButton disabled={disabledEdit} onClick={editSelectedRule}>
      <IconSelector icon="EditIcon" props={{ color: "kxOrange", sx: { fontSize: 18 } }} />
     </IconButton>
    </Stack>
   </Stack>
  </Paper>
 );
};

export default RuleToEdit;
